import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DomainActions } from '@app/core/actions';
import { DomainService } from '@app/core/services/domain.service';
import * as fromRoot from '@app/reducers';
import { select, Store } from '@ngrx/store';
import { Observable, ReplaySubject, of } from 'rxjs';
import { distinctUntilChanged, map, takeUntil, withLatestFrom } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadDomainIfExistsGuard {

  constructor(
    private store$: Store<fromRoot.State>,
    private readonly domainService: DomainService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  canActivate(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return of(true)
    }

    return this.loadDomain().pipe(map((domainLoaded: boolean) => {
      return domainLoaded;
    }));
  }

  loadDomain(): Observable<boolean> {
    const domainLoaded$ = new ReplaySubject<boolean>();
    const detectedDomain = this.domainService.detectDomain();

    this.store$.select(fromRoot.getLoadDomainError).pipe(
      takeUntil(domainLoaded$)
    ).subscribe((err: any) => {
      if (err) {
        domainLoaded$.next(true);
      }
    });

    this.store$.pipe(
      select(fromRoot.getCurrentDomain),
      distinctUntilChanged(),
      takeUntil(domainLoaded$),
    ).subscribe((currentDomain: any) => {
      if (!!currentDomain && currentDomain.domain === detectedDomain) {
        domainLoaded$.next(true);
      } else {
        this.store$.dispatch(DomainActions.loadDomain({ id: detectedDomain }));
        this.store$.pipe(
          takeUntil(domainLoaded$),
          withLatestFrom(
            this.store$.select(fromRoot.getCurrentDomainLoaded),
            this.store$.select(fromRoot.getCurrentDomain),
          ),
        ).subscribe(([_, domainLoaded, domain]: any[]) => {
          if (domainLoaded) {
            if (!!domain) {
              domainLoaded$.next(true);
            }
          }
        });
      }
    });
    return domainLoaded$.asObservable();
  }
}
